module.exports = __webpack_public_path__ + "static/media/Mema_Primary_Brandmark_1736357860614.17b10035.eps";